export default __webpack_public_path__ + "static/media/clock.11c26be6.PNG";